import React, { useRef, useState } from 'react';
import {Box } from "@mui/material";
import './App.css';
import FormComponent from './components/form';
import SuccessScreen from './components/success';
import ErrorScreen from './components/error';

function App() {
  const [page, setPage] = useState("form")

  const queryParams = new URLSearchParams(window.location.search);
  const campaign = queryParams.get('utm_campaign') ?? queryParams.get('campaign') ?? 'website';
  const campaign_details = queryParams.get('utm_content') ?? ""
  const show_how_did_you_hear = queryParams.get('show_hear') ?? true
  const redirect_url = queryParams.get('redirect') ? queryParams.get('redirect') : null
  const partnership = queryParams.get('utm_partnership') ?? queryParams.get('partnership') ?? ""


  const formMapping = {
    form:    <FormComponent campaign={campaign} setPage={setPage} campaign_details={campaign_details} show_how_did_you_hear={show_how_did_you_hear} partnership={partnership} />,
    success: <SuccessScreen page={page} redirectUrl={redirect_url} />,
    error:   <ErrorScreen />
  }
  

  return (
      <Box position="relative"  sx={{minWidth:"288px", maxWidth:"600px", background: page == "success" ? "white" : "transparent"}}>
        {formMapping[page]}
      </Box>
  );
}

export default App;
